import { Badge, type BadgeProps } from '@/components/ui/badge';
import type { AdminStatus } from '@/lib/admins-api';

export const ADMIN_STATUS_LABELS: Record<AdminStatus, string> = {
  ACTIVE: 'Actif',
  INVITED: 'Invité',
  SUSPENDED: 'Suspendu',
};

const VARIANTS: Record<AdminStatus, BadgeProps['variant']> = {
  ACTIVE: 'success-soft',
  INVITED: 'warning-soft',
  SUSPENDED: 'danger-soft',
};

export const AdminStatusBadge = ({ status }: { status: AdminStatus }) => (
  <Badge variant={VARIANTS[status]} data-testid="admin-status">
    {ADMIN_STATUS_LABELS[status]}
  </Badge>
);
